import React from "react";
import { Button, Card, Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

// Store
import { pathTitles, useStore } from "../../Store/Store";
import { YouTubeEmbed } from "../Common";

export const Interested = () => {
  const getLink = useStore((state) => state.getLink);
  const location = useLocation();

  // Check if we're on the puppies page
  const isOnPuppiesPage = location.pathname.includes(
    getLink(pathTitles.VIEWPUPPIES),
  );

  // Different YouTube videos for different pages
  const getVideoId = () => {
    const path = location.pathname;

    // Map pages to specific videos
    if (path === "/" || path.includes("home")) {
      return "ymrk4gEXdp0"; // Original - Home page
    } else if (path.includes(getLink(pathTitles.VIEWPUPPIES))) {
      return "3A8O_96LjfU"; // Puppies page
    } else if (path.includes(getLink(pathTitles.CHOOSINGAPUPPY))) {
      return "HkCtjhbaY10"; // Choosing a Puppy page
    } else if (path.includes(getLink(pathTitles.YOURPUPPYSTRAINING))) {
      return "1QL9AwWJve4"; // Training page
    } else if (path.includes(getLink(pathTitles.PUPPYDELIVERY))) {
      return "A0NXm9prDQI"; // Delivery page
    } else {
      // Default for Contact Us, City pages, etc.
      return "ymrk4gEXdp0";
    }
  };
  return (
    <Container className="interested_container small_container clear">
      <Card className="interested card_inner" style={{ padding: 0 }}>
        <Card.Title className="title">
          Ready to Welcome Your Fully Trained Puppy?
        </Card.Title>
        <Card.Subtitle
          style={{ marginBottom: "20px", fontSize: "1.1rem", color: "#666" }}
        >
          Skip the stress of puppy training. Get a house-trained, crate-trained,
          and socialized puppy delivered to your door.
        </Card.Subtitle>
        <YouTubeEmbed embedId={getVideoId()} />
        <div
          style={{
            display: "flex",
            gap: "15px",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "wrap",
            marginTop: "20px",
            width: "100%",
            padding: "0",
          }}
        >
          {!isOnPuppiesPage && (
            <Button
              className="card_button cedar"
              as={Link}
              to={getLink(pathTitles.VIEWPUPPIES)}
              size="lg"
              style={{
                padding: "15px 40px",
                fontSize: "1.1rem",
                fontWeight: "600",
                borderRadius: "8px",
              }}
            >
              View Available Puppies
            </Button>
          )}
          <Button
            variant="outline-primary"
            as="a"
            href="sms:+13179546952?body=Hi! I'm interested in learning more about your trained puppies."
            size="lg"
            style={{
              backgroundColor: "var(--cedar-primary)",
              border: "none",
              padding: "15px 40px",
              fontSize: "1.1rem",
              fontWeight: "600",
              borderRadius: "8px",
              color: "white",
            }}
          >
            Text Justine Now
          </Button>
        </div>
        <p
          style={{
            marginTop: "15px",
            fontSize: "0.9rem",
            color: "var(--almond-dark)",
            textAlign: "center",
          }}
        >
          ✓ Nationwide Delivery Available • ✓ Lifetime Training Support • ✓
          Health Guaranteed
        </p>
      </Card>
    </Container>
  );
};
